import { html, LitElement } from 'lit-element';
import { aggregateStyles } from '../cssUtils.js';

/**
 * @element inline-dropdown-aggregate
 * @prop {Object} model - The model for the pie
 * @prop {Object} aggregate - The aggregate
 */
export class InlineDropdownAggregate extends LitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      aggregate: { type: Array, attribute: false },
    };
  }

  _renderResponses() {
    const { responses, incorrect, averageScore, partiallyCorrect, correct } =
      this.aggregate || {};
    const { markup } = this.model || {};

    return html`
      <span>Responses: ${responses}</span><br />
      <span>Average Score: ${averageScore ? averageScore.toFixed(2) : 0}</span
      ><br />
      <span>Correct: ${correct}</span><br />
      <span>Partially Correct: ${partiallyCorrect}</span><br />
      <span>Incorrect: ${incorrect}</span><br />
      <span>Markup: ${markup}</span><br />
      <br />
    `;
  }

  _renderSelections() {
    const { selections } = this.aggregate || {};
    const { choices } = this.model || {};

    if (!selections) return html``;

    const categoryKeys = Object.keys(selections);

    return categoryKeys.map(categoryKey => {
      const categorySelections = Object.values(selections[categoryKey]);
      const categoryChoices = (choices && choices[categoryKey]) || [];

      return html`
        <span><strong>${categoryKey}:</strong></span>
        <br />
        ${categorySelections.map(selection => {
          const { value, count } = selection;
          const choice =
            (categoryChoices &&
              categoryChoices.find(ch => ch.value === value)) ||
            {};

          return html`
            <span>
              "${choice.label}" was selected ${count}
              time${count > 1 ? 's' : ''}
            </span>
            <br />
          `;
        })}
      `;
    });
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html` <style>
        ${aggregateStyles}
      </style>
      <div class="aggregate">
        ${this._renderResponses()} ${this._renderSelections()}
      </div>`;
  }
}

export default InlineDropdownAggregate;
